export default {
    menu:{
        home: '首頁',
        about:'關於我們',
        partners: '合作伙伴',
        contact:'聯絡我們'
    },
    home:{
        aboutPPTitle:'關於尊尚禮遇計劃',
        aboutPPIntro:'我們的尊尚禮遇計劃為家庭帶來無限樂趣和超值優惠！透過此計劃，您可以使用Monkey Coin購買各種精彩產品和體驗，以及日常必需品。讓您的家庭時光更加難忘，同時也能幫您省錢！',
        aboutPPSmallText1:'Monkey Coin 充值簡單、快捷。',
        aboutPPSmallText2:'為香港父母貼心設計的應用程式。',
        aboutPPSmallText3:'超過<span class="highlight-count">50間</span>本地親子商戶專屬優惠，折扣與體驗',
        monkeyCoinTitle:'享受活動和產品的最佳折扣。',
        'monkeyCoin-Excursion':'遊學團',
        'monkeyCoin-Fun':'童趣玩樂',
        'monkeyCoin-Premiums':'Monkey Tree<br>精選禮品',
        'monkeyCoin-Cash':'現金券',
        'monkeyCoin-Gift':'禮品兌換',
        'monkeyCoin-Complimentary' :'免費兌換',
        topUpCoinTitle:'儲值Monkey Coin',
        topPicks:'首選優惠',
        'top-fun':'童趣玩樂',
        'top-fun-smallText':'價值HK$370',
        'top-excursion':'遊學團',
        'top-excursion-20':'8',
        'top-excursion-endText':'折優惠',
        'top-cash':'現金券',
        learnMore:'了解更多',
        'member-Registration':'會員註冊',
        'member-Registration-intro': '立即下載Monkey Tree App，註冊成為會員，即可享有專屬禮遇！',
        'video-Tutorial': '影片教學',
        'video-registration':'註冊',
        registration1:'Monkey Tree App\n 註册 (學生)',
        registration2:'密碼找回',
        registration3:'變更語言設定',
        'video-redemption':'兌換',
        redemption1:'儲值Monkey Coin',
        redemption2:'現金券兌換',
        redemption3:'禮品兌換',
        redemption4:'免費兌換',
        redemption5:'娛樂兌換',
    },
    common:{
        bottomBarText:'立即註冊，享受專屬福利！',
        close:'关闭'
    },
    footer:{
        address:'香港太古城英皇道1111號25樓2514室',
        email:'信箱：enquiry@monkeytree.com.hk',
        tel:'電話：(852) 3563-6771',
        siteMap:'網站地圖',
        connect:'社交媒體',
        copyRight:'◎ Monkey Tree App. 版權所有。',
        privacy:'隱私權聲明',
        termUse:'使用條款',
    },
    contact:{
        contactUs:'聯絡我們',
        text:'只需填寫聯絡表格，我們將盡快與您聯繫！',
        name:'姓名:',
        email:'信箱:',
        message:'留言:',
        submit:'提交',
        tip1:'我們是本網站所收集資訊的唯一所有者。我們僅收集並存取您透過電子郵件或其他直接聯絡方式自願提供的資訊。我們不會將此資訊出售或出租給任何人。',
        tip2:'我們將使用您的資訊回覆您，解答您聯絡我們的原因。除滿足您的請求所需的情況外，我們不會與本組織以外的任何第三方分享您的資訊。'
    },
    about:{
        contact:'聯絡方式',
        socialMedia:'社群媒體',
        down:'下載 Monkey Tree App',
        mt:'Monkey Tree App',
        mtp1:'下載 Monkey Tree App，立刻開啟專屬家庭福利：賺取並儲值 Monkey Coins，換好禮、換體驗；輕鬆預訂精心策劃的戶外與親子活動，陪孩子一起學習、玩樂、增進感情；還能領超值現金券和商家專屬優惠，日常更省心省錢。',
        mtp2:"會員專屬好康、簡單的現金券兌換、安全付款與訂單管理，一應俱全。用最方便的方式，把更多美好親子時光帶回家。",
        AppFeatures:'應用功能',
        features1:'探索精彩的戶外活動和親子活動',
        features2:'充值 Monkey Coins，兌換精美家庭和兒童禮品',
        features3:'享商家專屬優惠，折扣',
        features4:'取得超值現金券',
        downApp:'下載應用',
        newFeatures3:'商家專屬優惠',
        newFeatureTitle1:'探索豐富的戶外活動與親子體驗',
        newFeatureP1:'精選香港各地一日遊學團 — 海洋公園、迪士尼樂園、挪亞方舟、巴士廠等等。' +
            '<br>想玩親子工作坊？體驗 PizzaExpress 披薩製作、雪糕製作等活動。' +
            '<br>立即查看完整行程報名啦。',
        newFeatureTitle2:'充值 Monkey Coins 換取親子好禮',
        newFeatureP2:'充值 $1,000 / $3,000 / $5,000 / $10,000 。可於 Monkey Tree 及合作品牌兌換限定禮品，或以積分換取各大景點門票 — 如海洋公園年票、冒險樂園幣、JP動感世界門票、Sandbox VR 體驗等。',
        newFeatureTitle3:'尊享商戶獨家優惠，立即省更多',
        newFeatureP3:'我們與 50+ 家信譽商戶合作。於店內出示 App ID 或於電商頁面輸入兌換碼，即可享 50+ 項折扣，包括免費兒童餐、升級遊玩套票及各類生活型優惠。',
        newFeatureTitle4:'實用現金券，超值折扣好選擇',
        newFeatureP4:'在 App 中即可找到本地日常所需的超值現金券 —— 百佳 / 惠康 / 759 阿信屋 / 優品 360 / 美心西餅 / A1 Bakery 等熱門商戶，優惠低至 7 折起。'

    },
    partners:{
        partnerTitle:'加入我們的大家庭',
        ourPartners:'我們的合作夥伴',
        ourPartnersIntro:'透過與超過 50 家本地及全球旅遊和生活方式合作夥伴攜手，將您的日常活動轉化為精彩獎勵和難忘體驗，從而提升您的產品服務。',
        partnerIntro:'作為香港首屈一指的親子獎賞平台合作夥伴，Monkey Tree 為您提供一個充滿活力的展示舞台，讓本地會員輕鬆發掘多元的兒童活動與親子生活體驗，擴展曝光、吸引家庭客群，一起把更多歡樂帶進香港家庭。',
        opportunities:'我們的合作夥伴可享有的幾項好處：',
        opportunities1:'接觸更多香港客戶，拓展實際業務機會',
        opportunities2:'透過多元渠道幫助品牌曝光，提升知名度',
        opportunities3:'獲取有價值的數據洞見，優化決策與行銷策略',
        opportunities4:'憑藉優質客群，實現長遠且具永續性的商業成長',
        together:'攜手共進，探索新天地…'
    }
}